var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "13px",
    height: "24px",
    viewBox: "0 0 13 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "CFF56E24-4FEC-4173-9B52-F9CDE8F964E6@2x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1-Sign-In-Filled-Out",
    transform: "translate(-882.000000, -390.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "facebook",
    transform: "translate(851.000000, 377.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "UI/Button-Copy-2",
    transform: "translate(-0.911429, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Button"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.9423075,13.5258094 L43.9423075,17.1748478 L41.7722354,17.1748478 C40.9797635,17.1748478 40.4453137,17.3407115 40.16887,17.672444 C39.8924264,18.0041764 39.7542066,18.5017676 39.7542066,19.1652324 L39.7542066,21.7776122 L43.8040863,21.7776122 L43.2650238,25.8689584 L39.7542066,25.8689584 L39.7542066,36.359944 L35.5246394,36.359944 L35.5246394,25.8689584 L32,25.8689584 L32,21.7776122 L35.5246394,21.7776122 L35.5246394,18.7643911 C35.5246394,17.0504402 36.0038012,15.7212267 36.9621393,14.7767108 C37.9204774,13.8321949 39.1967066,13.359944 40.7908652,13.359944 C42.1454393,13.359944 43.1959095,13.4152319 43.9423075,13.5258094 Z",
    id: "\\uF09A"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/facebook-icon.a51856c13b838276e788dd6807ebf0e3.svg";
export { ForwardRef as ReactComponent };